import React from 'react';
import TopBar from '../../Components/TopBar';
import Page from '../../Components/Containers/Page';
import Tabs, { Tab } from '../../Components/Containers/Tabs/Tabs';
import Services from './Services';
import Pricing from './Pricing';
import { usePreference } from '../../Data/Preference';
import Callback from '../../Services/Callback';
import Button from '../../Components/Button/Button';

const addServiceCallback = new Callback();
const addPricingCallback = new Callback();

const PricingAndServices = () => {
    const [activeTab, setActiveTab] = usePreference('pricingAndServicesTab', 'Services');

    return <>
        <TopBar left="/more"
            title="Services & Pricing"
            right={<Button theme="light"
                icon="Plus"
                onClick={() => activeTab === 'Services' ? addServiceCallback.invoke() : addPricingCallback.invoke()}
                zeroMargin
                noShadow
            />}
        />
        <Page>
            <Tabs selected={activeTab} onChange={setActiveTab}>
                <Tab title="Services">
                    <Services addServiceCallback={addServiceCallback} />
                </Tab>
                <Tab title="Pricing">
                    <Pricing addPricingCallback={addPricingCallback} />
                </Tab>
            </Tabs>
        </Page>
    </>
}

export default PricingAndServices;